import UserPrefsManager from "./user_prefs";

// "Enums"
export const ANALYSIS_RESULT = {
	ANALYSIS_UNKNOWN: 0,
	ANALYSIS_WITHIN_LIMITS: 1,
	ANALYSIS_ABOVE_LIMITS: 2,
	ANALYSIS_BELOW_LIMITS: 3,
	ANALYSIS_ABOVE_LIMITS_CRITICAL: 4,
	ANALYSIS_BELOW_LIMITS_CRITICAL: 5,
	ANALYSIS_OUT_OF_RANGE_CRITICAL: 6,
	ANALYSIS_TEMP_SENSOR_ABOVE_DIFF_LIMIT: 7,  // only used for differential analysis of temp sensor
	NO_ANALYSIS_DUE_TO_OPEN_STRING: 7  // only used for impedance
}

export const ANALYSIS_TYPE = {
	VOLTAGE: {
		"name": "Voltage",
		"unit": "V",
		"unit_round": 3,
		"diff_unit": "V",
		"diff_unit_round": 3,
		"blank": '--.---',
	},
	CURRENT: {
		"name": "Current",
		"unit": "A",
		"unit_round": 1,
		"diff_unit": "A",
		"diff_unit_round": 1,
		"blank": '--.-',
	},
	IMPEDANCE: {
		"name": "Impedance",
		"unit": "mΩ",
		"unit_round": 3,
		"diff_unit": "%",
		"diff_unit_round": 1,
		"blank": '-.---',
	},
	TEMPERATURE: {
		"name": "Temperature",
		"unit": "°",
		"unit_round": 1,
		"diff_unit": "°",
		"diff_unit_round": 1,
		"blank": '--.-',
	},
	DIFF_TEMPERATURE: {
		"name": "Differential Temperature",
		"unit": "°",
		"unit_round": 1,
		"diff_unit": "°",
		"diff_unit_round": 1,
		"blank": '--.-',
	},
	DISCHARGE_VOLTAGE: {
		"name": "Discharge Voltage",
		"unit": "V",
		"unit_round": 3,
		"diff_unit": "V",
		"diff_unit_round": 3,
		"blank": '--.---',
	},
};

export const STATE_COLOR = {
	UNKNOWN: '#748592',
	WITHIN_LIMITS: '#4B9C2E',
	MAINTENANCE: '#F4B235',
	CRITICAL: '#F22635',
};

export const ICON_STATE = {
	UNKNOWN: 'u',
	WITHIN_LIMITS: 'g',
	MAINTENANCE: 'y',
	CRITICAL: 'r'
};

export const DATA_ERROR_FLAG = {
	VALID_VALUE: 0,
	INVALID_VALUE: 1,
	OUTOFRANGE_VALUE: 2,
	BLANK_VALUE: 4
};

export const DATA_ERROR_VALUE = {
	INVALID_VALUE: -4000000,
	BLANK_VALUE: -4100000,
	OUTOFRANGE_VALUE: -4200000,
}

export const BATTERY_TYPE = {
	// 0: 'Unknown',
	0: '',
	1: 'Lead Acid VRLA',
	2: 'Lead Acid Flooded',
	3: 'NiCad',
	4: 'NiMH',
	5: 'NiFe',
	6: 'Lithium',
}

// Date Range Constants
export const DATE_RANGES = [
	{ name: '6 months', value: 6 },
	{ name: '1 Year', value: 12 },
	{ name: '2 Years', value: 24 },
	{ name: '3 Years', value: 36 },
	{ name: '4 Years', value: 48 },
	{ name: '5 Years', value: 60 },
	{ name: 'All Data', value: 'all' },
];

// "Enum" Functions
export function GetBVSModel(modelNumber) {
	if (modelNumber) {
		switch (modelNumber) {
			case 0:
				return 'Not Set';
			case 1:
				return 'LVIRA60';
			case 2:
				return 'LVIRA600';
			case 3:
				return 'S5';
			case 4:
				return 'S5 - Isolated Chargers';
			case 5:
				return 'L Controller';
			case 6:
				return 'L Controller - Isolated Chargers';
			case 7:
				return 'S3';
			case 8:
				return 'S4';
			case 9:
				return 'CellQ - VM DC';
			case 10:
				return 'CellQ - VM DC/AC';
			case 11:
				return 'CellQ2 - No Units';
			case 12:
				return 'CellQ2';
			case 13:
				return 'S5 - No Impedances';
			case 14:
				return 'S5 - Isolated Chargers, No Impedances';
			case 15:
				return 'CellQ - Not Used';
			case 16:
				return 'CellQ1';
			case 17:
				return 'CellQ1 - No Units';
			case 18:
				return 'Predictor';
			case 19:
				return 'Predictor - No Units';
			case 20:
				return 'CellQ1 - Isolated Chargers';
			case 21:
				return 'CellQ2 - Isolated Chargers';
			case 22:
				return 'CellQ - Canara';
			case 23:
				return 'CellQ - CellWatch';
			case 24:
				return 'CellQ - Alber';
			case 25:
				return 'S5 - Separate Interconnect Impedance';
			case 26:
				return 'S5 - Isolated Chargers, Separate Interconnect Impedance';
			default:
				return 'Unknown';

		}
	}

	return 'Unknown';
}

export function AnalysisResultToStateColor(analysisResult) {
	if (analysisResult) {
		switch (analysisResult) {
			case 0:  // ANALYSIS_UNKNOWN
				return STATE_COLOR.UNKNOWN;

			case 1:  // ANALYSIS_WITHIN_LIMITS
				return STATE_COLOR.WITHIN_LIMITS;

			case 2:  // ANALYSIS_ABOVE_LIMITS
				return STATE_COLOR.MAINTENANCE;

			case 3:  // ANALYSIS_BELOW_LIMITS
				return STATE_COLOR.MAINTENANCE;

			case 4:  // ANALYSIS_ABOVE_LIMITS_CRITICAL
				return STATE_COLOR.CRITICAL;

			case 5:  // ANALYSIS_BELOW_LIMITS_CRITICAL
				return STATE_COLOR.CRITICAL;

			case 6:  // ANALYSIS_OUT_OF_RANGE_CRITICAL
				return STATE_COLOR.CRITICAL;

			case 7:  // ANALYSIS_TEMP_SENSOR_ABOVE_DIFF_LIMIT
				return STATE_COLOR.CRITICAL;

			default:
				return STATE_COLOR.UNKNOWN;
		}
	} else {
		return STATE_COLOR.UNKNOWN;
	}
}

export function AnalysisResultToIconState(analysisResult) {
	if (analysisResult) {
		switch (analysisResult) {
			case 0:  // ANALYSIS_UNKNOWN
				return ICON_STATE.UNKNOWN;

			case 1:  // ANALYSIS_WITHIN_LIMITS
				return ICON_STATE.WITHIN_LIMITS;

			case 2:  // ANALYSIS_ABOVE_LIMITS
				return ICON_STATE.MAINTENANCE;

			case 3:  // ANALYSIS_BELOW_LIMITS
				return ICON_STATE.MAINTENANCE;

			case 4:  // ANALYSIS_ABOVE_LIMITS_CRITICAL
				return ICON_STATE.CRITICAL;

			case 5:  // ANALYSIS_BELOW_LIMITS_CRITICAL
				return ICON_STATE.CRITICAL;

			case 6:  // ANALYSIS_OUT_OF_RANGE_CRITICAL
				return ICON_STATE.CRITICAL;

			case 7:  // ANALYSIS_TEMP_SENSOR_ABOVE_DIFF_LIMIT
				return ICON_STATE.CRITICAL;

			default:
				return ICON_STATE.UNKNOWN;
		}
	} else {
		return ICON_STATE.UNKNOWN;
	}
}

export function AnalysisResultToStateText(analysisResult, analysisType) {
	let analysisResultText = '';
	if (analysisResult) {
		switch (analysisResult) {
			case 0:  // ANALYSIS_UNKNOWN
				analysisResultText =  'Unknown';
				break;

			case 1:  // ANALYSIS_WITHIN_LIMITS
				analysisResultText =  'Within Limits';
				break;

			case 2:  // ANALYSIS_ABOVE_LIMITS
				analysisResultText =  'Above Maintenance Limits';
				break;

			case 3:  // ANALYSIS_BELOW_LIMITS
				analysisResultText =  'Below Maintenance Limits';
				break;

			case 4:  // ANALYSIS_ABOVE_LIMITS_CRITICAL
				analysisResultText =  'Upper Critical limits';
				break;

			case 5:  // ANALYSIS_BELOW_LIMITS_CRITICAL
				analysisResultText =  'Lower Critical limits';
				break;

			case 6:  // ANALYSIS_OUT_OF_RANGE_CRITICAL
				analysisResultText =  'Out of Range';
				break;

			case 7:  // ANALYSIS_TEMP_SENSOR_ABOVE_DIFF_LIMIT
				if (analysisType === ANALYSIS_TYPE.DIFF_TEMPERATURE) {
					analysisResultText = 'Above Temp Differential Limit';
				} else if (analysisType === ANALYSIS_TYPE.IMPEDANCE) {
					analysisResultText = 'Open String';
				}
				break;

			default:
				analysisResultText =  'Unknown';
				break;
		}
	} else {
		analysisResultText = 'Unknown';
	}

	return `${analysisResultText}: `;
}

export function UnitAnalysisToStateText(analysisResult, analysisType, analysisOut = null, userTimeZone = 'America/New_York') {

	const analysisTypeText = analysisType ? analysisType.name : 'Analysis';

	let analysisResultText = '';
	if (analysisResult) {
		switch (analysisResult) {
			case 0:  // ANALYSIS_UNKNOWN
				analysisResultText =  'Unknown';
				break;

			case 1:  // ANALYSIS_WITHIN_LIMITS
				analysisResultText =  'is within limits';
				break;

			case 2:  // ANALYSIS_ABOVE_LIMITS
				analysisResultText =  'is above Maintenance Limits';
				break;

			case 3:  // ANALYSIS_BELOW_LIMITS
				analysisResultText =  'is below Maintenance Limits';
				break;

			case 4:  // ANALYSIS_ABOVE_LIMITS_CRITICAL
				analysisResultText =  'is exceeding upper Critical limits';
				break;

			case 5:  // ANALYSIS_BELOW_LIMITS_CRITICAL
				analysisResultText =  'is below lower Critical limits';
				break;

			case 6:  // ANALYSIS_OUT_OF_RANGE_CRITICAL
				analysisResultText =  'is out of range';
				break;

			case 7:  // ANALYSIS_TEMP_SENSOR_ABOVE_DIFF_LIMIT
				if (analysisType === ANALYSIS_TYPE.DIFF_TEMPERATURE) {
					analysisResultText = 'is exceeding the Temperature Differential Limit';
				} else if (analysisType === ANALYSIS_TYPE.IMPEDANCE) {
					analysisResultText = 'has no analysis due to Open String';
				}
				break;

			default:
				analysisResultText =  'Unknown';
				break;
		}
	} else {
		analysisResultText = 'Unknown';
	}

	let analysisOutText = '';
	if (analysisOut && analysisOut > new Date(1990, 1, 1)) {
		const options = {
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			second: '2-digit',
			timeZone: userTimeZone,
		};

		analysisOutText = 'since' + new Date(analysisOut).toLocaleString(undefined, options);;
	}

	return `${analysisTypeText} ${analysisResultText} ${analysisOutText}`;
}

// Global functions

// Check if the object passed is empty
export function isEmpty(obj) {
	for (const prop in obj) {
		if (Object.hasOwn(obj, prop)) {
			return false;
		}
	}
	return true;
}

// Valid value checking
export function validValue(value, defaultValue = null) {
	return isValidValue(value) ? value : defaultValue;
}

export function isValidValue(value) {
	return (value !== undefined &&
		value !== null &&
		value !== DATA_ERROR_VALUE.INVALID_VALUE &&
		value !== DATA_ERROR_VALUE.BLANK_VALUE &&
		value !== DATA_ERROR_VALUE.OUTOFRANGE_VALUE);
}

// Check for and evaluate data flags
export function isValidDataFlags(value, dataFlags = 0x00) {
	const flags = dataFlags & 0xFF;

	if ((flags & 0x01) === 0x01) {
		return DATA_ERROR_VALUE.INVALID_VALUE;
	} else if ((flags & 0x02) === 0x02) {
		return DATA_ERROR_VALUE.OUTOFRANGE_VALUE;
	} else if ((flags & 0x04) === 0x04) {
		return DATA_ERROR_VALUE.BLANK_VALUE;
	} else {
		return value;
	}
}

export function dataFlagsToText(value, dataFlags, units = '') {
	const flags = dataFlags & 0xFF;

	if (value == null || value === undefined ||
		(flags & 0x01) === 0x01 || value === DATA_ERROR_VALUE.INVALID_VALUE) {
		return 'Invalid';
	} else if ((flags & 0x02) === 0x02 || value === DATA_ERROR_VALUE.OUTOFRANGE_VALUE) {
		return 'Out of Range';
	} else if ((flags & 0x04) === 0x04 || value === DATA_ERROR_VALUE.BLANK_VALUE) {
		return '';
	} else {
		return value + units;
	}
}

export function evaluateRiskIndex(riskIndex, riskFlags, digits = 1) {
	const flags = riskFlags & 0xFF;
	const riskSet = (flags & 0x01) === 0x01;
	const inoperable = (flags & 0x02) === 0x02;
	const riskValid = (flags & 0x04) === 0x04;

	if (riskSet) {
		if (riskValid) {
			return riskIndex.toFixed(digits);
		} else {
			if (inoperable) {
				return 'Inoperable';
			} else {
				return 'Invalid';
			}
		}
	} else {
		return 'Unknown';
	}
}

// Parse the analysis result for voltage and impedance into a more usable format
export function parseAnalysisResult(analysis_result, fields) {
	let result = 0;
	if (typeof analysis_result === 'string') {
		result = parseInt(analysis_result, 10);
		if (isNaN(result)) {
			result = 0;
		}
	} else if (typeof analysis_result === 'number') {
		result = analysis_result;
	} else {
		result = 0;
	}

	const parsed = {};
	fields.forEach(field => {
		parsed[field.name] = (result >> field.shift) & field.mask;
	});
	return parsed;
}

// Parse the analysis result for voltage into a more usable format
export function parseVoltageAnalysisResult(analysis_result) {
	return parseAnalysisResult(analysis_result, [
		{ name: 'voltage', shift: 0, mask: 0x0F },
		{ name: 'voltageSlope', shift: 8, mask: 0x0F },
		{ name: 'dischargeVoltage', shift: 16, mask: 0x0F },
	]);
}

// Parse the analysis result for impedance into a more usable format
export function parseImpedanceAnalysisResult(analysis_result) {
	return parseAnalysisResult(analysis_result, [
		{ name: 'impedance', shift: 0, mask: 0x0F },
		{ name: 'impedanceSlope', shift: 8, mask: 0x0F },
		{ name: 'openUnit', shift: 16, mask: 0x0F },
	]);
}

// Parse datetime string to Date object
export function parseDateTime(dateTimeStr) {
	if (dateTimeStr !== undefined && dateTimeStr.length === 14) {
		const year = parseInt(dateTimeStr.substr(0, 4), 10);
		const month = parseInt(dateTimeStr.substr(4, 2), 10) - 1; // JavaScript months are 0-based
		const day = parseInt(dateTimeStr.substr(6, 2), 10);
		const hour = parseInt(dateTimeStr.substr(8, 2), 10);
		const minute = parseInt(dateTimeStr.substr(10, 2), 10);
		const second = parseInt(dateTimeStr.substr(12, 2), 10);

		return new Date(Date.UTC(year, month, day, hour, minute, second));
	} else {
		return null;
	}
}

// Format Date/Time object to proper string
export function formatDateTime(datetime, defaultText = '') {
	// Get the user's timezone and time format from local storage
	const userTimeZone = UserPrefsManager.get('userTimeZone') || 'America/New_York';
	const userTimeFormat = UserPrefsManager.get('userTimeFormat') || '12';

	const options = {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		second: '2-digit',
		timeZone: userTimeZone,
		hour12: userTimeFormat === '12',
	};

	if (datetime !== undefined) {
		const eventDateTime = new Date(datetime);
		const compareDateTime = new Date(1990, 0, 1); // January is month 0 in JavaScript
	
		if (eventDateTime !== undefined && eventDateTime > compareDateTime) {
			return eventDateTime.toLocaleString(undefined, options);
		}
	}

	return defaultText;
};

// Format Date object to proper string
export function formatDate(date, defaultText = '') {
	// Get the user's timezone from local storage
	let userTimeZone = UserPrefsManager.get('userTimeZone') || 'America/New_York';

	const options = {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		timeZone: userTimeZone,
	};

	if (date !== undefined) {
		const eventDate = new Date(date);
		const compareDate = new Date(1990, 0, 1); // January is month 0 in JavaScript
		
		if (eventDate !== undefined && eventDate > compareDate) {
			return eventDate.toLocaleString(undefined, options);
		}
	}

	return defaultText;
};

// Formats the passed Date object to a string in the user's preferred time format
export function formatTime(time) {
	// Retrieve user's timezone and format preference from local storage
	const userTimeFormat = UserPrefsManager.get('userTimeFormat') || '24'; // Default to 24-hour format if not set
	
	// If the user prefers 24-hour format, return the input time
	if (userTimeFormat === '24') {
		return time;
	}

	// Parse the 24-hour time string
	const [hours, minutes, seconds] = time.split(':').map(Number);

	// Determine AM/PM designation
	const period = hours >= 12 ? 'PM' : 'AM';

	// Convert hours to 12-hour format
	const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight

	// Format the time string in 12-hour format
	const time12 = `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${period}`;

	return time12;
}

// Convert a number of total seconds into proper xx:xx:xx time format
export function formatSecondsToTime(seconds) {
	if (typeof seconds !== 'number' || seconds < 0) {
		return '--:--:--';
	}

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	const formattedHours = hours.toString();
	const formattedMinutes = minutes.toString().padStart(2, '0');
	const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

	return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

// Returns { measText, outText }
export function buildMeasurementText(value, isMeasValid, diffValue, analysisResult, stateType, roundingOverride = null, diffRoundingOverride = null, blankValueOverride = null) {
    const tempMeasurementUnits = userMetricUnits() ? '°C' : '°F';

	let isTempMeas = stateType === ANALYSIS_TYPE.TEMPERATURE || stateType === ANALYSIS_TYPE.DIFF_TEMPERATURE;

    // Format measurement text
    let measText = blankValueOverride !== null ? blankValueOverride : stateType.blank;
    if (isValidValue(value) && isMeasValid && analysisResult !== 0) {
        const measDecimals = roundingOverride !== null ?
            roundingOverride :
            (stateType.unit_round ? stateType.unit_round : 3);

        measText = `${value.toFixed(measDecimals)} ${stateType.unit}`;

        if (isTempMeas) {
            let converted = measUnitsConversion(value).toFixed(1);
            measText = `${converted} ${tempMeasurementUnits}`;
        }
    }

    // Format diff text
    let outText = '';
    if (isValidValue(diffValue) && analysisResult !== 0 && diffValue !== 0) {
        const outSign = diffValue > 0 ? '+' : '';

        const outDecimals = diffRoundingOverride !== null ?
            diffRoundingOverride :
            (stateType.diff_unit_round ? stateType.diff_unit_round : 3);

        outText = `(${outSign}${diffValue.toFixed(outDecimals)} ${stateType.diff_unit})`;

        if (isTempMeas) {
            let outValue = measUnitsConversion(diffValue, true).toFixed(1);
            outText = `(${outSign}${outValue} ${tempMeasurementUnits})`;
        }
    }

    return { measText, outText };
}

export function MeasurementStatetoHTML(stateName, state, stateType, roundingOverride = null, diffRoundingOverride = null) {
	if (state && stateType) {
	
		// Measurement and Difference values and units
		let measValue = state.value;
		let diffValue = state.difference;
		let analysisResult = state.result;

		// Evaluate if the analysis is for differential temperature and if it's valid. Don't display an "unknown" diff temp analysis
		if (stateType === ANALYSIS_TYPE.DIFF_TEMPERATURE && measValue === 0 && analysisResult === 0) {
			return;
		}

		const measurementText = buildMeasurementText(measValue, true, diffValue, analysisResult, stateType, roundingOverride, diffRoundingOverride, "UNKNOWN");

		const color = AnalysisResultToStateColor(analysisResult);
		const finalText = `${stateName} ${stateType.name}: ${measurementText.measText}${measurementText.outText}`; 
		
		return (
			<span style={{ color: color }}>
				{finalText}
			</span>
		);
	} else {
		return (
			<p color={STATE_COLOR.UNKNOWN}> {stateType}: UNKNOWN</p>
		);
	}
}

// Function to convert statistics to HTML for display
export function StatisticsSectionToHTML(statisticData, analysisType) {
	const { counts } = statisticData;
	const result = [];

	const indicesToProcess = new Set(counts.map((_, index) => index));
	indicesToProcess.add(1); // Add index 1 (Within_limits) to ensure it's always included

	// Sort indices in descending order to show the worst analysis_result first
	const sortedIndices = Array.from(indicesToProcess).sort((a, b) => b - a);

	// Iterate over the sorted indices
	sortedIndices.forEach(index => {
		const count = counts[index] || 0; // Default to 0 if the count is undefined
		if (count > 0 || index === 1) {
			const color = AnalysisResultToStateColor(index);
			const text = AnalysisResultToStateText(index, analysisType);

			result.push(
				<p
					key={`${analysisType.name}-${index}`}
					style={{
						color,
						margin: '2px 0',
						lineHeight: '1.2',
						paddingLeft: '15px',
						fontSize: '14px',
					}}
				>
					{text}{count}
				</p>
			);
		}
	});

	return (
		<div>
			<p
				style={{
					color: 'gray',
					fontWeight: 'bold',
					fontSize: '14px',
					marginBottom: '5px',
				}}
			>
				{analysisType.name}
			</p>
			{result}
		</div>
	);
}

// Get the user's metric vs imperial measurement units preference
export function getUserMeasUnits() {
	return UserPrefsManager.get('userMeasUnits') || 'metric';
}

// Check if the user prefers metric measurement units
export function userMetricUnits() {
	return getUserMeasUnits() === 'metric';
}

// Convert Measurement Temperature Units based on metric/imperial user preference
export function measUnitsConversion(tempMeasurement, isDifferential = false) {
	if (userMetricUnits()) {
		return tempMeasurement;
	} else {
		let converted = tempMeasurement * 1.8;
		return isDifferential ? converted : converted + 32;
	}
};

// Convert Measurement Temperature Units in an array based on metric/imperial user preference
export function measUnitsArrayConversion(measurementArray, isDifferential = false) {
	if (userMetricUnits()) {
		return measurementArray;
	} else {
		return measurementArray.map(measurement => {
			let converted = measurement * 1.8;
			return isDifferential ? converted : converted + 32;
		});
	}
};

// Convert a disctionary of query parameters to a query string
export function dictToQueryString(dict) {
	const queryParams = Object.keys(dict)
		.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(dict[key]))
		.join('&');
	return (queryParams && queryParams.length > 0) ? '?' + queryParams : '';
}

// Compare two arrays to see if they contain the same values
export function arraysContainSameElements(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return false;
	}

	const sortedArr1 = [...arr1].sort();
	const sortedArr2 = [...arr2].sort();

	for (let i = 0; i < sortedArr1.length; i++) {
		if (sortedArr1[i] !== sortedArr2[i]) {
			return false;
		}
	}

	return true;
}

// Compare two objects to see if they are equal. Works for primitives, arrays, and nested objects.
export function deepCompare(obj1, obj2) {
	// Check for same reference first
	if (obj1 === obj2) return true;

	// Check for null or not an object next
	if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
		return obj1 === obj2;
	}

	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	// Verify number of keys next
	if (keys1.length !== keys2.length) return false;

	// Finally, compare each key and value recursively
	for (const key of keys1) {
		if (!keys2.includes(key) || !deepCompare(obj1[key], obj2[key])) {
			return false;
		}
	}

	return true;
};